import { render, staticRenderFns } from "./addRole.vue?vue&type=template&id=34a16fec&scoped=true&"
import script from "./addRole.vue?vue&type=script&lang=js&"
export * from "./addRole.vue?vue&type=script&lang=js&"
import style0 from "./addRole.vue?vue&type=style&index=0&id=34a16fec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34a16fec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/agent/workspace/98-prod-frontend-deploy-tke/mgr-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34a16fec')) {
      api.createRecord('34a16fec', component.options)
    } else {
      api.reload('34a16fec', component.options)
    }
    module.hot.accept("./addRole.vue?vue&type=template&id=34a16fec&scoped=true&", function () {
      api.rerender('34a16fec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/roleComponents/addRole.vue"
export default component.exports